import { Component, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@core/authentication/Authentication.service';
import { environment } from '@envs/environment';

@Component({
  selector: 'app-email-invite',
  imports: [],
  templateUrl: './email-invite.component.html',
})
export class EmailInviteComponent {
  private readonly router = inject(Router);
  private readonly rutaActiva = inject(ActivatedRoute);
  private readonly authService = inject(AuthenticationService);
  Email: string;
  url = environment;

  constructor() {
    this.Email = this.rutaActiva.snapshot.params['email'];
    localStorage.setItem('email', this.Email);
    if (this.rutaActiva.snapshot.data['validate'] === true) {
      this.router.navigate(['']);
    } else if (this.rutaActiva.snapshot.data['validate'] === false) {
      this.authService.DeleteUserFirebase(this.Email).subscribe((x) => {
        this.router.navigate(['']);
      });
    }
  }
}
